const Color={
    online:"#4cdb4c",
    offline:"#dd3e3e",
    snoozed:"#efef2d",
    orange: "#f28809",  
}

export default Color